module.exports = __webpack_public_path__ + "img/coffin.1669fe26.svg";